import { Component, OnInit, ViewChild } from '@angular/core';
import { AbastecimentosLubrificantesService } from './abastecimentos-lubrificantes.service';
import { AbastecimentoLubrificante } from '../../../../types/AbastecimentoLubrificante.type';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { ToastService } from '../../../../services/toast.service';


interface ModuloOrigem {
    id: string,
    nome: string
}

@Component({
  selector: 'app-abastecimentos-lubrificantes',
  templateUrl: './abastecimentos-lubrificantes.component.html',
  styleUrl: './abastecimentos-lubrificantes.component.css'
})
export class AbastecimentosLubrificantesComponent implements OnInit{

  @ViewChild('dt') tabela!: Table

  loading: boolean = false;
  apontamentos: AbastecimentoLubrificante[] = [];
  totalRegistros: number = 0;
  modulos: ModuloOrigem[] = [{id: 'MNFABAST', nome: 'Abastecimentos'}, {id: 'MNFLUBRI', nome: 'Lubrificantes'}]
  modulosSelecionados!: ModuloOrigem

  constructor(private service: AbastecimentosLubrificantesService, private toast: ToastService){}

  ngOnInit(): void {    
  }

  atualizar() {
    this.tabela.reset();
  }

  filter(event: Event){
    console.log(event)
  }


  buscarApontamentos(event: TableLazyLoadEvent) {

    this.loading = true;

    const pagina = (event.first ?? 0) / (event.rows ?? 10)
    const tamanho = event.rows ?? 10;

    const filtro = (event.globalFilter as string) || '';

    let modulo = (this.modulosSelecionados) || '';

    this.service.getApontamentos(pagina, tamanho, filtro, modulo?.id).subscribe({
      next: (value) => {

        this.apontamentos = value.content;
        this.totalRegistros = value.totalElements;

      },error: (err) => {
        
        this.loading = false;

        this.toast.erro("Erro ao buscar", "Erro ao buscar os registros: " + err);

      }, complete: () => {
        this.loading = false
        
      },
    })

  }


}
